import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {LocalStripeService} from "./local.stripe.service";
import {Invoice} from "../../model/invoice";
import {Observable} from "rxjs/Observable";

@Injectable()
export class  InvoiceResolver implements  Resolve<Invoice>{

  constructor (private stripeService:LocalStripeService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Invoice | Observable<Invoice> | Promise<Invoice> {

    let customerid;
    let invoiceid;

    customerid = route.params['id'];
    invoiceid = route.params['inv'];

    const invoice$ = this.stripeService.getInvoiceByKey(customerid,invoiceid)
      .first();

    return invoice$;

    // throw new Error("Method not implemented.");
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/stripe/invoice-resolver.ts